import React, {Component} from "react";
import {Link} from "react-router-dom";
import {ClientCard} from "./ClientCard";
import {Spinner} from "../Spinner";
import {LinkToSection} from "../elements/LinkToSection";
import {LocalStorage} from "../../utils/LocalStorage";
import {APIClient} from "../../utils/APIClient";
import {API_URL} from "../../settings/local_settings";
import {withTranslation} from 'react-i18next';
import {MagnifyingGlass, WarningCircle, Plus} from '@phosphor-icons/react';

class AgencyClientsList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showInactive: false,
            onlyUrgent: false,
            searchQuery: '',
            summaryData: null,
        };
    }

    componentDidMount() {
        this.fetchSummary();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.clients !== this.props.clients) {
            this.fetchSummary();
        }
    }

    fetchSummary() {
        new APIClient(API_URL + 'agency/clients/summary/').call('GET')
            .then((data) => {
                if (data && data.status === 'OK' && Array.isArray(data.data)) {
                    this.setState({summaryData: data.data});
                }
            })
            .catch(() => {
                // Summary endpoint not available yet, cards work with basic data
            });
    }

    getEnrichedClients() {
        if (!this.props.clients) return null;
        const {summaryData} = this.state;
        if (!summaryData) return this.props.clients;

        const summaryMap = {};
        summaryData.forEach(s => { summaryMap[s.id] = s; });

        return this.props.clients.map(client => ({
            ...client,
            ...(summaryMap[client.id] || {}),
        }));
    }

    getFilteredClients() {
        const clients = this.getEnrichedClients();
        if (!clients) return null;

        let filtered = clients;

        // Active/inactive filter
        if (!this.state.showInactive) {
            filtered = filtered.filter(client => client.active);
        }

        // Only urgent filter (clients with alerts)
        if (this.state.onlyUrgent) {
            filtered = filtered.filter(client => (client.alerts_count || 0) > 0);
        }

        // Search filter
        const query = this.state.searchQuery.trim().toLowerCase();
        if (query) {
            filtered = filtered.filter(client =>
                client.name.toLowerCase().includes(query)
            );
        }

        return filtered;
    }

    renderCards() {
        const filteredClients = this.getFilteredClients();
        const {t} = this.props;

        if (filteredClients !== null) {
            return (
                <div className="client-cards-list">
                    {filteredClients.map((client) =>
                        <ClientCard
                            key={client.id}
                            client={client}
                            canDelete={this.props.isSuperAdmin === true && this.props.myClientsMode !== true}
                            onDelete={() => {
                                if (window.confirm(t('client_cards.delete_confirm', {name: client.name}))) {
                                    this.props.doAgencyClientDelete(client.id);
                                }
                            }}
                        />
                    )}
                </div>
            );
        } else {
            return (
                <div className="box-loader">
                    <Spinner color="positive"/>
                </div>
            );
        }
    }

    render() {
        const {t} = this.props;

        if (this.props.myClientsMode === true) {
            return (
                <div className="section-body-item -wide">
                    <label>{t('agency_client_list.my_clients_help_text')} <LinkToSection url={"/user/" + LocalStorage.fetchUserId() + "/module/marketing"} text={t('agency_client_list.go_edit_client_assignment')}/></label>
                    {this.renderCards()}
                </div>
            );
        }

        const hasInactiveClients = this.props.clients && this.props.clients.some(client => !client.active);

        return (
            <div className="client-cards-container">
                <div className="client-cards-header">
                    <div className="client-cards-search">
                        <span className="search-icon"><MagnifyingGlass size={16}/></span>
                        <input
                            type="text"
                            placeholder={t('client_cards.search_placeholder')}
                            value={this.state.searchQuery}
                            onChange={(e) => this.setState({searchQuery: e.target.value})}
                        />
                    </div>

                    <button
                        className={`client-cards-filter-btn${this.state.onlyUrgent ? ' active' : ''}`}
                        onClick={() => this.setState({onlyUrgent: !this.state.onlyUrgent})}
                    >
                        <WarningCircle size={16}/> {t('client_cards.only_urgent')}
                    </button>

                    {hasInactiveClients && (
                        <button
                            className={`client-cards-filter-btn${this.state.showInactive ? ' active' : ''}`}
                            onClick={() => this.setState({showInactive: !this.state.showInactive})}
                        >
                            {t('agency_client_list.show_inactive')}
                        </button>
                    )}

                    <div className="client-cards-actions">
                        <Link className="client-cards-add-btn" to="/agency/clients/new/onboarding">
                            <Plus size={16} weight="bold"/> {t('client_cards.new_client')}
                        </Link>
                    </div>
                </div>
                {this.renderCards()}
            </div>
        );
    }
}

export default withTranslation()(AgencyClientsList);
